module.exports = {"620111001":"窑街街道","620111003":"矿区街道","620111004":"华龙街道","620111101":"海石湾镇","620111102":"花庄镇","620111103":"平安镇","620111104":"红古镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620111.json
// module id = 3033
// module chunks = 0